__turbopack_context__.v({
  "container": "Slider-module__2GBFrq__container",
  "control": "Slider-module__2GBFrq__control",
  "header": "Slider-module__2GBFrq__header",
  "indicator": "Slider-module__2GBFrq__indicator",
  "label": "Slider-module__2GBFrq__label",
  "mark": "Slider-module__2GBFrq__mark",
  "markFilled": "Slider-module__2GBFrq__markFilled",
  "slider": "Slider-module__2GBFrq__slider",
  "thumb": "Slider-module__2GBFrq__thumb",
  "track": "Slider-module__2GBFrq__track",
  "value": "Slider-module__2GBFrq__value",
});
